import { render, staticRenderFns } from "./GestionAmbiental.vue?vue&type=template&id=28b66aee&scoped=true"
import script from "./GestionAmbiental.vue?vue&type=script&lang=js"
export * from "./GestionAmbiental.vue?vue&type=script&lang=js"
import style0 from "./GestionAmbiental.vue?vue&type=style&index=0&id=28b66aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b66aee",
  null
  
)

export default component.exports